import React from 'react';
import { X, Check } from 'lucide-react';

const wontFind = ['Boring flavours', 'Ingredient lists nobody understands', 'Pretending snacks aren\u2019t snacks', 'Sneaky sugar bombs'];
const willFind = ['Real ingredients', 'Big flavours', 'Serious crunch', 'No unnecessary preservatives'];

const WhatYouWont = () => {
  return (
    <section id="story" className="px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-6">
        <div className="bg-[#1a1a1a] text-[#FFF4E6] rounded-3xl crunch-shadow p-8 md:p-10">
          <div className="inline-flex items-center gap-2 bg-[#E63946] px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest">
            <X size={14} /> Nope
          </div>
          <h3 className="font-display text-3xl md:text-5xl uppercase mt-4">What you won’t find here.</h3>
          <ul className="mt-6 space-y-3">
            {wontFind.map((w) => (
              <li key={w} className="flex items-start gap-3 font-brico text-lg">
                <span className="mt-1 w-6 h-6 rounded-full bg-[#E63946] flex items-center justify-center flex-shrink-0"><X size={14} /></span>
                {w}
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-[#FFD84D] rounded-3xl crunch-shadow p-8 md:p-10">
          <div className="inline-flex items-center gap-2 bg-[#1a1a1a] text-[#FFF4E6] px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest">
            <Check size={14} /> Yes
          </div>
          <h3 className="font-display text-3xl md:text-5xl uppercase mt-4">What you will.</h3>
          <ul className="mt-6 space-y-3">
            {willFind.map((w) => (
              <li key={w} className="flex items-start gap-3 font-brico text-lg">
                <span className="mt-1 w-6 h-6 rounded-full bg-[#1a1a1a] text-[#FFF4E6] flex items-center justify-center flex-shrink-0"><Check size={14} /></span>
                {w}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhatYouWont;
